import styled from "styled-components";

export const PosterMakerTabWrapper = styled.div`
  margin-top: 22px;
  width: calc(100% - 40px);
  height: 50px;
  padding: 18px 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;

  border-radius: 14px;
  border: 1px solid #d9d9d9;
  background: #fff;
  box-shadow: 0 2.829px 2.829px 0 rgba(0, 0, 0, 0.25);
`;

export const PosterMakerTabLeftWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
`;

export const PosterMakerTabLeftButton = styled.div<{ selected: boolean }>`
  padding: 13px 20px;
  border-radius: 15px;
  background: ${(props) => (props.selected ? "#7f25fb" : "#fff")};
  color: ${(props) => (props.selected ? "#fff" : "#BEBEBE ")};
  cursor: pointer;
`;

export const PosterMakerTabRightWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  color: #000;
  text-align: center;
  font-family: Pretendard;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;

  > .text {
    padding: 13px 20px;
  }

  > img {
    cursor: pointer;
  }
`;
